import icons from '../../../../../world/spa/libs/icons';

const getWorldIcon = icons.getWorldIcon;

export default {
    namespaced: true,
    state: {
        indexHref: '/',
        appName: 'ANM22 Calendar',
        appLogo: require('../../../../../world/libs/anm22_icons/img/apps/app-calendar.png'),
        mapsAPIKey: 'AIzaSyCROLZgMtm6KHWCguvlw8Rb0Lj3YmkDlvE',
    },
    getters: {
        HBTheme: state => {
            return {
                appImg: getWorldIcon('calendarIcon'),
                appName: 'ANM22 Calendar',
                appNameColor: "#f00",               
            }
        },
        getMapsKey: state => {
            return state.mapsAPIKey;
        }
    },
    mutations: {
    },
    actions: {
        
    }
}